import { Skeleton } from "@material-ui/lab";
import Tooltip from "./Tooltip";
import { InfoOutlined } from "@material-ui/icons";
import { Typography } from "@material-ui/core";

export default function Statistic({
    title,
    value,
    prefix = null,
    suffix = null,
    loading = false,
    titleClassName = '',
    tooltipContent = null,
    filterLegend,
    headerAction
}) {
    const normalizedValue = value === undefined || value === null || value === '' ? '-' : value;

    return (
        <div className="text-start">
            <div className={`text-base text-gray-600 ${titleClassName}`}>
                {loading ? (
                    <Skeleton variant="rect" height={16} width={120} />
                ) : (
                    <div className="flex items-center justify-between gap-2">

                        <div className="flex items-center gap-1 min-w-0">
                            <div className="truncate text-xs">
                                {title}
                            </div>

                            {tooltipContent && (
                                <Tooltip arrow title={tooltipContent}>
                                    <span style={{ display: "inline-flex", cursor: "help" }}>
                                        <InfoOutlined style={{ fontSize: 14, color: "#9ca3af" }} />
                                    </span>
                                </Tooltip>
                            )}
                        </div>

                        {headerAction &&
                            <div className="flex-shrink-0">{headerAction}</div>
                        }
                    </div>
                )}
            </div>
            <div className="mt-2 flex gap-1 leading-none items-center text-xl min-h-[24px]">
                {loading ? (
                    <Skeleton variant="rect" height={20} width={64} />
                ) : (
                    <>
                        {prefix && (
                            <span className="mr-1">
                                {prefix}
                            </span>
                        )}
                        <div translate="no" className="font-medium">{normalizedValue}</div>
                        {suffix && (
                            <div className="ml-2 text-lg text-gray-600">
                                {suffix}
                            </div>
                        )}
                    </>
                )}
            </div>
            {!loading && filterLegend && (
                <div
                    className={`mt-2 text-xs text-gray-500 whitespace-nowrap overflow-hidden text-ellipsis`}
                    title={filterLegend}
                >
                    <Typography variant="caption" style={{ fontWeight: 600 }}>{filterLegend}</Typography>
                </div>
            )}
        </div>
    );
}
